export enum PriceTypes {
    FETCH_FORECAST_KEY = '@Price/FETCH_FORECAST_KEY',
    FETCH_INIT_RUN_FORECAST_LOOKUP = '@Price/FETCH_INIT_RUN_FORECAST_LOOKUP',
    FETCH_INIT_RUN_FORECAST_RAW_LOOKUP = '@Price/FETCH_INIT_RUN_FORECAST_RAW_LOOKUP',
}
